module.exports = __webpack_public_path__ + "img/cns_mac13.f3a6a60b.png";